let loading;

// Load the official prebuilt distribution locally, without bundling the engine twice.
export function loadCesium() {
  if (window.Cesium) return Promise.resolve(window.Cesium);
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      window.CESIUM_BASE_URL = '/cesium/';
      const script = document.createElement('script');
      script.src = '/cesium/Cesium.js';
      script.async = true;
      script.onload = () => window.Cesium ? resolve(window.Cesium) : reject(new Error('Cesium initialization failed'));
      script.onerror = () => { script.remove(); loading = null; reject(new Error('Cesium could not load')); };
      document.head.appendChild(script);
    });
  }
  return loading;
}